import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class WhiteBackgroundService implements OnDestroy {
  readonly bodyCSSClasses = ['bg-color-white', 'u-minHeight-100vh'];

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  init() {
    this.document.querySelector('html').classList.add('bg-color-white');
    this.bodyCSSClasses.forEach((cssClass) =>
      this.document.body.classList.add(cssClass),
    );
  }

  ngOnDestroy() {
    this.document.querySelector('html').classList.remove('bg-color-white');
    this.bodyCSSClasses.forEach((cssClass) =>
      this.document.body.classList.remove(cssClass),
    );
  }
}
